import sileo from 'sileo';

const StaffingBalance = new sileo.Model('bposeats', 'staffing-balance');
const CompanyStaffingDeposit = new sileo.Model('bposeats', 'staffing-deposit');
const CompanyUsers = new sileo.Model('hqzen', 'admin-company-users');
const CompanyUsersGroup = new sileo.Model('hqzen', 'simple-admin-company-users');
const UserProfile = new sileo.Model ('hqzen', 'user-profile');
const UserProfiles = new sileo.Model ('hqzen', 'user-profiles');
const UserProfileWorkforces = new sileo.Model('hqzen', 'user-profile-workforces');

const state = {
    balance: {}
};

const getters = {
    avgJobOfferSalary: state => state.balance.average_job_offer_salary,
};

const mutations = {
    updateBalance(state, balance) {
        state.balance = balance;
    }
};

const actions = {
    fetchStaffingBalance({ commit }, pk) {
        return StaffingBalance.objects.get(pk)
            .then(response => {
                commit('updateBalance', response);
                return response;
            });
    },

    createStaffingDeposit(state, payload) {
        return CompanyStaffingDeposit.objects.create(payload);
    },

    fetchCompanyUsers(context, filters) {
        return CompanyUsers.objects.filter(filters);
    },

    fetchCompanyUsersGroup(context, filters) {
        return CompanyUsersGroup.objects.filter(filters);
    },

    fetchUserProfiles(context, filters) {
        return UserProfile.objects.filter(filters);
    },

    async fetchBatchUserProfiles(context, filters) {
        const userPks = filters['pk__in'];
        const count = userPks.length;
        const sizePerRequest = 100;
        const batchRequests = [];
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        async function fetchWithRetry(apiCall, retries=3, backoff=100) {
            for (let attempt = 0; attempt <= retries; attempt++) {
                try {
                    return await apiCall();
                } catch (error) {
                    console.error(`Batch request failed (Attempt ${attempt+1}):`, error);
                    if (attempt < retries) await delay(backoff*(attempt+1));
                }
            }
            throw new Error('API call failed after maximum reties');
        }

        // Create batch API calls
        for (let top = 0; top < count; top += sizePerRequest) {
            const batchPks = userPks.slice(top, top + sizePerRequest);
            const batchFilters = { ...filters, pk__in: batchPks, batch_size: sizePerRequest };
            batchRequests.push(async () => {
                await delay(top); // Stagger API calls
                return fetchWithRetry(() => UserProfile.objects.filter(batchFilters));
            });
        }

        try {
            // Execute API calls concurrently
            const usersData = await Promise.allSettled(batchRequests.map(apiCall => apiCall()));
            // Collect successful responses
            const users = usersData
                .filter(result => result.status === 'fulfilled')
                .flatMap(result => result.value || []);

            return users;
        } catch (error) {
            console.error(`Error in fetchBatchUserProfiles: ${error}`);
            return [];
        }
    },

    fetchUsersProfiles(context, filters) {
        return UserProfiles.objects.filter(filters);
    },

    fetchUserProfileWorkforces(context, filters) {
        return UserProfileWorkforces.objects.filter(filters);
    }
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
